import React from 'react';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useForm } from 'react-hook-form';
import FormTextField from 'Components/FormTextField';
import ModalContent from '../ModalContent';
import { withStyles } from '@material-ui/core';
import history from '../../history';

const styles = (theme) => ({});

function FoundItem({ setActiveModal }) {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: {},
  });

  const onSubmit = async (data) => {
    const { tagCode } = data;
    setActiveModal('none');

    history.push(`/i/${tagCode}`);
  };

  const getHelperText = () => {
    if (errors.tagCode) {
      return errors.tagCode.message;
    }

    return "Please enter the 6 digit code. It's case sensitive.";
  };

  return (
    <ModalContent
      title="Found Something?"
      buttonText="Submit"
      onFormSubmit={handleSubmit(onSubmit)}
      formContents={
        <FormTextField
          fullWidth
          label="Tag Code"
          name="tagCode"
          margin="normal"
          inputProps={{
            maxLength: 6,
          }}
          required
          error={!!errors.tagCode}
          helperText={getHelperText()}
          inputRef={register({
            required: 'Please enter 6 digit code',
            pattern: {
              value: /^[A-Z0-9]{6}$/i,
              message: 'Code must be 6 digits',
            },
          })}
          placeholder="Enter Tag Code"
        />
      }
    />
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      passwordReset: actions.passwordReset,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(
  connect(null, mapDispatchToProps)(withStyles(styles)(FoundItem)),
);
